export default function validarSomenteNumeros(valor) {
  return valor.match(/^\d+$/);
}
